import { cn } from '../../lib/cn';

const colorMap: Record<string, string> = {
  blue: 'bg-blue-100 text-blue-800',
  green: 'bg-green-100 text-green-800',
  red: 'bg-red-100 text-red-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  purple: 'bg-purple-100 text-purple-800',
  pink: 'bg-pink-100 text-pink-800',
  indigo: 'bg-indigo-100 text-indigo-800',
  orange: 'bg-orange-100 text-orange-800',
  gray: 'bg-gray-100 text-gray-700',
  slate: 'bg-slate-100 text-slate-700',
};

interface BadgeProps {
  children: React.ReactNode;
  color?: keyof typeof colorMap | string;
  size?: 'sm' | 'md';
  className?: string;
}

export function Badge({ children, color = 'gray', size = 'sm', className }: BadgeProps) {
  const colorClass = colorMap[color] ?? colorMap.gray;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        size === 'sm' ? 'px-2 py-0.5 text-2xs' : 'px-2.5 py-1 text-xs',
        colorClass,
        className,
      )}
    >
      {children}
    </span>
  );
}
